// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__XZRCs","skeleton-animation":"styles_skeleton-animation__mp1uP","button":"styles_button__D3i0q"};